import { useContext } from 'react';
import { DisplayDateType, TranslateType } from '../core/localization';
import { LocaleCtx } from '../contexts/locale.context';
import Logger from '../libs/logger';
import { LogArea } from '../libs/logger/const';

export interface useLocaleResult {
  translate: TranslateType;
  displayDate: DisplayDateType;
}

const useLocale = (): useLocaleResult => {
  const ctx = useContext(LocaleCtx);
  let translate: TranslateType = ctx?.translate;
  if (!ctx?.translate) {
    Logger.info(['context locale without translate', ctx], LogArea.Localization);
    translate = (messageId) => 'NotImple: ' + messageId;
  }
  const displayDate: DisplayDateType = ctx?.displayDate;
  return { translate, displayDate };
};

export default useLocale;
